/**
 * Collections Review — Suggest Edit accept/cancel + spinner.
 *
 * Accept: POSTs to /api/tools/kb/suggest/ to save the suggestion as a pending variant.
 * Cancel: clears the suggestion card.
 * Spinner: shows on the parent dropdown button during AI generation.
 */

(function () {

    document.body.addEventListener('click', function (e) {
        var accept = e.target.closest('.js-suggest-edit-accept');
        var cancel = e.target.closest('.js-suggest-edit-cancel');
        if (!accept && !cancel) return;

        var card = (accept || cancel).closest('[id^="suggest-edit-result-"]');
        if (!card) return;

        if (accept) {
            var text = card.querySelector('.suggest-edit-text');
            if (!text) return;

            var token = window._cc && window._cc.getCsrfToken ? window._cc.getCsrfToken() : '';

            fetch('/api/tools/kb/suggest/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': token,
                },
                body: JSON.stringify({
                    variant_id: parseInt(accept.dataset.variantId),
                    variant_type: accept.dataset.variantType,
                    suggested_content: text.textContent.trim(),
                    reason: accept.dataset.reason || '',
                }),
            }).then(function (resp) {
                if (resp.ok) {
                    SeeMe.toast.success('Edit suggestion saved');
                } else {
                    resp.json().then(function (data) {
                        SeeMe.toast.error(data.error || 'Failed to save suggestion');
                    }).catch(function () {
                        SeeMe.toast.error('Failed to save suggestion');
                    });
                }
            }).catch(function () {
                SeeMe.toast.error('Network error — try again');
            });
        }

        // Clear the card either way
        var wrapper = card.parentElement;
        if (wrapper) wrapper.innerHTML = '';
    });

    // Spinner on parent Suggest Edit button during AI request
    function isSuggestRequest(evt) {
        var target = evt.detail.elt.getAttribute('hx-target') || '';
        return target.indexOf('suggest-edit-wrapper') !== -1;
    }

    var _activeBtn = null;

    document.body.addEventListener('htmx:beforeRequest', function (evt) {
        if (!isSuggestRequest(evt)) return;
        var dropdown = evt.detail.elt.closest('.dropdown');
        _activeBtn = dropdown ? dropdown.querySelector('[data-dropdown]') : null;
        if (!_activeBtn) return;
        var icon = _activeBtn.querySelector('i');
        if (icon) {
            icon.setAttribute('data-original-class', icon.className);
            icon.className = 'fa-solid fa-spinner fa-spin';
        }
    });

    document.body.addEventListener('htmx:afterRequest', function (evt) {
        if (!isSuggestRequest(evt)) return;
        if (_activeBtn) {
            var icon = _activeBtn.querySelector('i');
            if (icon && icon.hasAttribute('data-original-class')) {
                icon.className = icon.getAttribute('data-original-class');
                icon.removeAttribute('data-original-class');
            }
            _activeBtn = null;
        }
    });

})();
